// extracted by mini-css-extract-plugin
export default {"root":"_1i_ez","dot":"P3LCT","current":"_3drJT"};